import { Tag, Typography } from 'antd'

const MontanTag = ({ montant }: { montant: number }) => (
  <Tag>
    <Typography.Text type="secondary">
      {montant
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
      €
    </Typography.Text>
  </Tag>
)
const DemandeMontant = ({
  minmontant,
  maxmontant,
}: {
  minmontant: number | null | undefined
  maxmontant: number | null | undefined
}) => {
  const montant = minmontant === maxmontant ? minmontant : null
  if (montant) return <MontanTag montant={montant} />
  return (
    <>
      {!!minmontant && <MontanTag montant={minmontant} />}
      {maxmontant && <MontanTag montant={maxmontant} />}
    </>
  )
}

export default DemandeMontant
